import Component from '@glimmer/component';
import { PrismTooltip } from '@mylighthouse/prism-ember';
import { modifier } from 'ember-modifier';
import type { MarketInsightHotel } from 'lumen/utils/market-insight/market-insight-helpers';
import { getCompsetIndicatorCssClass } from 'lumen/utils/market-insight/market-insight-helpers';

interface HotelMarketInsightTablesCellsTdHotelNameSignature {
  Args: {
    column: {
      setHighlightedMarker: (hotelId: string, isHovered: boolean) => void;
    };
    displayValue: string;
    value: MarketInsightHotel;
  };
}

export default class HotelMarketInsightTablesCellsTdHotelName extends Component<HotelMarketInsightTablesCellsTdHotelNameSignature> {
  handleHotelHover = modifier((tdElement) => {
    const hotelId = this.args.value.our_hotel_id;
    const trElement = tdElement.closest('tr');

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    const rowMenuMouseEnterHandler = () => {
      this.args.column.setHighlightedMarker(hotelId, true);
    };

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    const rowMenuMouseLeaveHandler = () => {
      this.args.column.setHighlightedMarker(hotelId, false);
    };

    // Add hover listeners to the tr element to highlight the row hotel on the map.
    trElement?.addEventListener('mouseenter', rowMenuMouseEnterHandler);
    trElement?.addEventListener('mouseleave', rowMenuMouseLeaveHandler);

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    return () => {
      trElement?.removeEventListener('mouseenter', rowMenuMouseEnterHandler);
      trElement?.removeEventListener('mouseleave', rowMenuMouseLeaveHandler);
    };
  });

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get dotIndicatorType() {
    return getCompsetIndicatorCssClass(this.args.value);
  }

  <template>
    <div class="flex items-center justify-start" {{this.handleHotelHover}}>
      <div
        class="compset-dot-indicator compset-dot-indicator--{{this.dotIndicatorType}}
          mr-200"
      ></div>

      <div class="truncate">
        {{@displayValue}}
      </div>
    </div>

    <PrismTooltip @side="right" @text={{@displayValue}} />
  </template>
}
